import { splitBalanced, createCustomProperty } from '@sail/engine';
export const paddingTopProp = createCustomProperty('--padding-top', {
    initialValue: '0px'
});
const paddingRightProp = createCustomProperty('--padding-right', {
    initialValue: '0px'
});
export const paddingBottomProp = createCustomProperty('--padding-bottom', {
    initialValue: '0px'
});
const paddingLeftProp = createCustomProperty('--padding-left', {
    initialValue: '0px'
});
function parseBoxModelShorthand(value) {
    const [top, right, bottom, left] = splitBalanced(value);
    var _ref;
    return [
        top,
        right !== null && right !== void 0 ? right : top,
        bottom !== null && bottom !== void 0 ? bottom : top,
        (_ref = left !== null && left !== void 0 ? left : right) !== null && _ref !== void 0 ? _ref : top
    ];
}
function marginX(value, set) {
    set.property('marginLeft', value);
    set.property('marginRight', value);
}
function marginY(value, set) {
    set.property('marginTop', value);
    set.property('marginBottom', value);
}
function paddingX(value, set) {
    set.property('paddingLeft', value);
    set.property('paddingRight', value);
}
function paddingY(value, set) {
    set.property('paddingTop', value);
    set.property('paddingBottom', value);
}
const paddingProps = {
    paddingTop: paddingTopProp,
    paddingRight: paddingRightProp,
    paddingBottom: paddingBottomProp,
    paddingLeft: paddingLeftProp
};
function setPaddingProperty(set, property, value) {
    const paddingProp = paddingProps[property];
    set.property(paddingProp, value);
}
function createPaddingPlugin(property) {
    return function paddingPlugin(value, set) {
        // `value` can sometimes be the string 'undefined'; bail out if so
        // TODO(koop): Figure out why this is happening
        if (value === 'undefined') {
            return;
        }
        if (property) {
            const paddingStr = [
                set.var(paddingTopProp),
                set.var(paddingRightProp),
                set.var(paddingBottomProp),
                set.var(paddingLeftProp)
            ].join(' ');
            set.property(property, ()=>{
                set.property('padding', paddingStr, {
                    skipPlugin: true
                });
                setPaddingProperty(set, property, value);
            });
        } else {
            // Clear out existing longhand values so the shorthand takes precedence
            set.property('paddingTop', undefined);
            set.property('paddingRight', undefined);
            set.property('paddingBottom', undefined);
            set.property('paddingLeft', undefined);
            set.property('padding', ()=>{
                const [top, right, bottom, left] = parseBoxModelShorthand(value);
                set.property('padding', value);
                setPaddingProperty(set, 'paddingTop', top);
                setPaddingProperty(set, 'paddingRight', right);
                setPaddingProperty(set, 'paddingBottom', bottom);
                setPaddingProperty(set, 'paddingLeft', left);
            });
        }
    };
}
const negative = (value)=>`calc(-1 * ${value})`;
function createBleedPlugin(...marginProperties) {
    return function bleedPlugin(value, set) {
        marginProperties.forEach((marginProperty)=>{
            if (value === 'auto') {
                if (process.env.NODE_ENV !== 'production') {
                    throw new Error(`Bleed 'auto' is not supported. Please use fixed values instead.'`);
                }
            } else {
                set.property(marginProperty, negative(value));
            }
        });
    };
}
export const pluginsBoxModel = {
    marginX,
    marginY,
    padding: createPaddingPlugin(),
    paddingTop: createPaddingPlugin('paddingTop'),
    paddingBottom: createPaddingPlugin('paddingBottom'),
    paddingLeft: createPaddingPlugin('paddingLeft'),
    paddingRight: createPaddingPlugin('paddingRight'),
    paddingX,
    paddingY,
    bleed: createBleedPlugin('marginTop', 'marginBottom', 'marginLeft', 'marginRight'),
    bleedX: createBleedPlugin('marginLeft', 'marginRight'),
    bleedY: createBleedPlugin('marginTop', 'marginBottom'),
    bleedTop: createBleedPlugin('marginTop'),
    bleedBottom: createBleedPlugin('marginBottom'),
    bleedLeft: createBleedPlugin('marginLeft'),
    bleedRight: createBleedPlugin('marginRight')
};

//# sourceMappingURL=pluginsBoxModel.experimental.js.map